import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-new',
  templateUrl: './header-new.component.html',
  styleUrls: ['./header-new.component.less']
})
export class HeaderNewComponent implements OnInit {
  isShown:boolean=false;
  appLogo: string;
  public icon = 'menu'; 
  
  public toggleIcon() {
      if (this.icon === 'menu') {
          this.icon = 'clear';
      } else {
          this.icon = 'menu'
      }
  }
  
  public hideMenu(){
    this.icon = 'menu';
    this.isShown = false;
  }
  constructor() { 
    this.appLogo = '../../assets/images/akrti-logo1.png';
  }

  ngOnInit() {
  }

}
